export default __webpack_public_path__ + "static/media/WalletConnect.d99a0ef0.svg";